import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn, FaArrowRightLong } from "react-icons/fa6";
import heroImage from "../../img4.jpeg";
import ScrollReveal from "../ScrollReveal/ScrollReveal";
import Home2 from "./Home2";
import Type from "./Type";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import "./home.css";

const highlights = [
  "Modular backend architecture",
  "Webhook and event workflows",
  "Security and production ownership",
];

const metrics = [
  { value: "5+", label: "Years in production engineering" },
  { value: "Node", label: "Backend focus with NestJS" },
  { value: "E2E", label: "Architecture to production support" },
];

const heroSnippet = [
  "const engineer = {",
  "  name: 'Shankar Kharel',",
  "  stack: ['Node.js', 'TypeScript', 'NestJS'],",
  "  focus: ['webhooks', 'security', 'integrations'],",
  "  status: 'shipping production systems',",
  "};",
];

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-shell">
          <Row className="hero-grid align-items-center">
            <Col lg={7}>
              <ScrollReveal className="home-copy" distance={34}>
                <span className="eyebrow">
                  Balkumari, Lalitpur, Nepal <span className="eyebrow-dot" />{" "}
                  Backend Engineering
                </span>
                <h1 className="hero-title">Shankar Kharel</h1>
                <p className="hero-role">
                  Backend Engineer (Node.js/TypeScript/NestJS) for integrations,
                  webhooks, and security-focused systems.
                </p>
                <div className="hero-contact">
                  <a href="tel:+9779807592153">+977 9807592153</a>
                  <span />
                  <a href="mailto:itsshankar35@gmail.com">
                    itsshankar35@gmail.com
                  </a>
                </div>
                <p className="hero-lead">
                  Backend-focused Software Engineer and Team Lead with 5+ years of
                  experience building production systems across mobile and web
                  products. Strong in TypeScript, Node.js, and NestJS, with
                  hands-on work designing modular backend patterns, secure APIs,
                  and event-driven integrations.
                </p>
                <div className="hero-type">
                  <Type />
                </div>
                <div className="hero-actions">
                  <Link className="button-primary" to="/project">
                    View Projects <FaArrowRightLong />
                  </Link>
                  <Link className="button-secondary" to="/about">
                    About Me
                  </Link>
                </div>
                <div className="hero-mini-note">
                  PostgreSQL, MySQL, deployment automation, end-to-end delivery,
                  and production support.
                </div>
                <div className="hero-links">
                  <a
                    href="https://github.com/shankarkharel"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="GitHub"
                  >
                    <AiFillGithub />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/shankar-kharel-162846168/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                </div>
              </ScrollReveal>
            </Col>

            <Col lg={5}>
              <ScrollReveal
                className="hero-visual-column"
                variant="left"
                delay={80}
                distance={38}
              >
                <div className="hero-image-frame">
                  <div className="hero-visual-top">
                    <span className="status-pill">Developer | Designer | Tinkerer</span>
                    <span className="hero-wave" role="img" aria-label="wave">
                      👋🏻
                    </span>
                  </div>
                  <img src={heroImage} alt="Shankar Kharel hero" />
                </div>
                <pre className="hero-snippet">
                  <code>{heroSnippet.join("\n")}</code>
                </pre>
              </ScrollReveal>
            </Col>
          </Row>

          <Row className="hero-metrics">
            {metrics.map((item) => (
              <Col md={4} key={item.label}>
                <ScrollReveal delay={110 + metrics.indexOf(item) * 90}>
                  <div className="metric-card">
                    <strong>{item.value}</strong>
                    <span>{item.label}</span>
                  </div>
                </ScrollReveal>
              </Col>
            ))}
          </Row>

          <ScrollReveal as="section" className="focus-strip" delay={120} distance={26}>
            <div className="section-intro compact">
              <span className="section-kicker">Core Strengths</span>
              <h2>Production backend work with clean delivery patterns.</h2>
            </div>
            <div className="focus-grid">
              {highlights.map((item) => (
                <ScrollReveal
                  as="article"
                  className="focus-card"
                  key={item}
                  delay={140 + highlights.indexOf(item) * 80}
                  distance={22}
                >
                  <span className="focus-index">0{highlights.indexOf(item) + 1}</span>
                  <p>{item}</p>
                </ScrollReveal>
              ))}
            </div>
          </ScrollReveal>
        </Container>
      </Container>
      <Home2 />
      <ScrollToTop />
    </section>
  );
}

export default Home;
